<template>
  <div class="group-list">
    <ConfigTable
      ref="ct"
      :searchConfig="searchConfig"
      :tableColumns="tableColumns"
      :tableData="list"
      :total="total"
      @change="loadData"
      @delete="delRow"
      @edit="editRow"
      @add="addGroup"
    ></ConfigTable>
    <UpdateAiPlaza ref="editDialog" @success="successCallback" />
  </div>
</template>

<script>
import ConfigTable from "@/components/ConfigTable";
import VideoPlayIcon from "./components/VideoPlayIcon";
import API from "@/api";
import Gallery from "@/components/Gallery";
import { changeDate } from "@/utils/filter";
import UpdateAiPlaza from "./components/UpdateAiPlaza";
const typeFilterFun = (v) => {
  switch (v) {
    case 1:
      return "ai图片换脸";
    case 2:
      return "ai视频换脸";
    case 3:
      return "ai脱衣";
    case 4:
      return "ai图生视频";
    case 5:
      return "ai绘画";
    default:
      return "-";
  }
};
const searchConfig = [
  { type: "button", icon: "search", placeholder: "搜索", key: "search" },
  // { type: "button", icon: "plus", placeholder: "新增", key: "add" },
];
const tableColumns = () => [
  { name: "ID", key: "id", width: 220 },
  { name: "标题", key: "title", width: 100 },
  { name: "用户id", key: "uid", width: 100 },
  {
    name: "原图",
    key: "originalImage",
    component: Gallery,
    props: (val) => ({ list: val }),
  },
  {
    name: "生成的图",
    key: "generateImage",
    component: Gallery,
    props: (val) => ({ list: val }),
  },
  {
    name: "原视频",
    key: "originalVideo",
    component: VideoPlayIcon,
    props: (val, row) => ({ url: val, videoInfo: row }),
  },
  {
    name: "生成的视频",
    key: "generateVideo",
    component: VideoPlayIcon,
    props: (val, row) => ({ url: val, videoInfo: row }),
  },
  {
    name: "原视频封面",
    key: "originalVideoCover",
    component: Gallery,
    props: (val) => ({ list: val }),
  },
  {
    name: "生成的视频封面",
    key: "generateVideoCover",
    component: Gallery,
    props: (val) => ({ list: val }),
  },
  { name: "置顶排序号", key: "sortCode" },
  { name: "输入的原文", key: "originContent", width: 200 },
  { name: "原因", key: "reason", width: 200 },
  {
    name: "状态",
    key: "status",
    valueHandler: (v) =>
      v == 1 ? "审核通过" : v == 2 ? "拒绝" : v == 3 ? "下架" : "待审核",
  },
  { name: "关联模版id", key: "template", width: 140 },
  {
    name: "类型",
    key: "type",
    valueHandler: typeFilterFun,
  },
  { name: "收藏数", key: "collectCount" },
  { name: "评论数", key: "commentCount" },
  { name: "点赞数", key: "likeCount" },
  { name: "关联订单id", key: "orderId" },
  { name: "浏览数", key: "viewCount" },
  { name: "审核时间", key: "reviewAt", valueHandler: changeDate },
  { name: "创建时间", key: "createdAt", valueHandler: changeDate },
  { name: "更新时间", key: "updatedAt", valueHandler: changeDate },
  {
    name: "操作",
    fixed: "right",
    actions: [
      {
        action: "edit",
        key: "refresh",
        text: "修改",
      },
      "delete",
    ],
  },
];
export default {
  name: "AiPlazaList",
  components: { ConfigTable, UpdateAiPlaza },
  data() {
    return {
      searchConfig,
      total: 0,
      list: [],
      appOpts: [],
    };
  },
  computed: {
    tableColumns() {
      return tableColumns(this);
    },
  },
  watch: {},
  mounted() {},
  methods: {
    successCallback() {
      this.$refs.ct.search();
    },
    async loadData(params) {
      try {
        const newParams = {};
        Object.keys(params).forEach((key) => {
          if (params[key] !== "") newParams[key] = params[key];
        });
        const r = await API.geTaiplazaList(newParams);
        const data = r.data;
        this.total = data.total;
        this.list = data.list;
      } catch (error) {
        console.error("查询失败：", error);
      }
    },
    addGroup() {
      this.$refs.editDialog.open();
    },
    editRow(row) {
      this.$refs.editDialog.open(row);
    },
    async delRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const r = await API.deleteAiplaza({ id: row.id });
        if (r.code === 200) {
          this.$message.success("已删除");
          this.$refs.ct.search();
        } else {
          this.$message.error(r.tip);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.group-list {
}
</style>
